import { loadModules } from "esri-loader";
import { Vue } from "vue-property-decorator";
import MapToolTip from "./MapToolTip.vue";

export default class ToolTip {
  public id: string = "tooltip1";
  private view!: __esri.SceneView | __esri.MapView;
  private vm!: Vue;
  private position!: any;
  private xoffset: number = 0;
  private yoffset: number = 0;
  private anchor: string = "top";
  private defaultVisible: boolean = true;
  private zooms: [number, number] = [0, 100];
  private bubble: boolean = false;

  public constructor(view: __esri.SceneView | __esri.MapView, props: any, graphic: any) {
    this.view = view;
    this.position = graphic.geometry || graphic;

    this.defaultVisible = props.visible !== false;
    if (props.zooms) {
      this.zooms = props.zooms;
      if (this.view.zoom <= props.zooms[1] && this.view.zoom >= props.zooms[0]) {
        props.visible = this.defaultVisible;
      } else {
        props.visible = false;
      }
    }
    let vue: any = props.vue || MapToolTip;
    this.xoffset = props.xoffset || 0;
    this.yoffset = props.yoffset || 0;
    this.anchor = props.anchor || "top";
    this.bubble = props.bubble === true;
    this.create(vue, props);
  }

  private create(vue: any, props: any) {
    this.vm = new Vue({
      // 为什么不使用 template 要使用render 因为现在是webpack里面没有编译器 只能使用render
      render: h => h(vue, { props }), // render 生成虚拟dom  {props: props}
    }).$mount(); // $mount 生成真实dom, 挂载dom 挂载在哪里, 不传参的时候只生成不挂载，需要手动挂载
    let className = props.className || "tooltip";
    if (!this.vm.$el.classList.contains(className)) {
      this.vm.$el.classList.add(className);
    }
    if (!this.defaultVisible) {
      Object(this.vm.$el).style.display = "none";
    }
    if (this.bubble) {
      this.view.container.appendChild(this.vm.$el);
    } else {
      this.view.container.children[0].children[0].appendChild(this.vm.$el);
    }

    this.changeText();
    this.init();
  }

  //计算tooltip，偏移位置；
  private subLocate(location: string): { xoffset: number; yoffset: number } {
    let xoffset: number = 0;
    let yoffset: number = 0;
    const width = this.vm.$el.clientWidth;
    const height = this.vm.$el.clientHeight;

    switch (location) {
      case "top":
        xoffset = 0 - width / 2 + this.xoffset;
        yoffset = 0 - height - this.yoffset;
        break;
      case "left-top":
        xoffset = 0 - width + this.xoffset;
        yoffset = 0 - height - this.yoffset;
        break;
      case "right-top":
        xoffset = 0 + this.xoffset;
        yoffset = 0 - height - this.yoffset;
        break;
      case "bottom":
        xoffset = 0 - width / 2 + this.xoffset;
        yoffset = this.yoffset;
        break;
      case "left-bottom":
        xoffset = 0 - width + this.xoffset;
        yoffset = 0 - this.yoffset;
        break;
      case "right-bottom":
        xoffset = 0 + this.xoffset;
        yoffset = 0 - this.yoffset;
        break;
      case "left":
        xoffset = 0 - width + this.xoffset;
        yoffset = 0 - height / 2 - this.yoffset;
        break;
      case "right":
        xoffset = 0 + this.xoffset;
        yoffset = 0 - height / 2 - this.yoffset;
        break;
      case "center":
        xoffset = 0 - width / 2 + this.xoffset;
        yoffset = 0 - height / 2 + this.yoffset;
        break;
    }
    return { xoffset: xoffset, yoffset: yoffset };
  }

  private init() {
    let o: any = this;
    console.log(this.vm, 1111);
    // this.vm.$el.addEventListener("click", e => {
    //   console.log("我是摸一个点击了");
    // });
    o.view.watch("extent", (event: any) => {
      let zoom = o.view.zoom;
      if (zoom <= o.zooms[1] && zoom >= o.zooms[0]) {
        o.changeText();
      }
    });

    o.view.watch("zoom", (newValue: any) => {
      //层级控制visibility属性,
      let zoom = Math.round(newValue);
      if (o.defaultVisible) {
        if (zoom <= o.zooms[1] && zoom >= o.zooms[0]) {
          o.vm.$el.style.visibility = "visible";
        } else {
          o.vm.$el.style.visibility = "hidden";
          o.vm.$el.style.left = "-1000px";
          o.vm.$el.style.top = "-1000px";
        }
      }
    });
  }

  private async changeText() {
    if (Object(this.vm.$el).style.visibility !== "hidden" && Object(this.vm.$el).style.diplay !== "none") {
      const center = await this.getPostion(this.position);
      const point = this.view.toScreen(center);

      const offset = this.subLocate(this.anchor);

      Object(this.vm.$el).style.left = point.x + offset.xoffset + "px";
      Object(this.vm.$el).style.top = point.y + offset.yoffset + "px";
    }
  }

  private async getPostion(geometryObj: any) {
    const [geometryJsonUtils] = await loadModules(["esri/geometry/support/jsonUtils"]);
    let center = geometryJsonUtils.fromJSON(geometryObj);
    if (center.type == "polyline") {
      center = center.extent.center;
    } else if (center.type == "extent") {
      center = center.center;
    } else if (center.type == "polygon" || center.type == "circle") {
      center = center.centroid;
    }
    return center;
  }

  public remove() {
    // 回收组件
    if (this.bubble) {
      this.view.container.removeChild(this.vm.$el); // 删除元素
    } else {
      this.view.container.children[0].children[0].removeChild(this.vm.$el); // 删除元素
    }
    this.vm.$destroy(); // 销毁组件
  }

  public static clear(view: any, id?: string | undefined, className?: string) {
    let tools: any = document.getElementsByClassName(className || "tooltip");

    Array.from(tools).forEach((el: any, index: number) => {
      if (id == undefined || el.id == id) {
        el.parentElement.removeChild(el);
      }
    }, this);
  }

  public hide() {
    Object(this.vm.$el).style.display = "none";
    Object(this.vm.$el).style.visibility = "hidden";
    this.defaultVisible = false;
  }

  public show() {
    Object(this.vm.$el).style.display = "block";
    Object(this.vm.$el).style.visibility = "visible";
    this.defaultVisible = true;
    this.changeText();
  }
}
